import { Injectable } from '@angular/core';
import { HttpEvent, HttpInterceptor, HttpHandler, HttpRequest } from '@angular/common/http';
import { Router } from '@angular/router';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { AuthService } from './services/auth.service';
import { config } from '../core/config';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  constructor(
    private authService: AuthService,
    private router: Router,
  ) { }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if (config.auth === 'session') {
      request = request.clone({
        withCredentials: true
      });
    }

    return next.handle(request).pipe(catchError((error) => {
      if (error.status === 401) {
        this.authService.doLogoutAndRedirectToLogin();
      }

      if (error.status === 403) {
        this.router.navigate(['/']);
      }

      return throwError(error);
    }));
  }
}
